import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgYoutube = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 24,
		height: 24,
		rx: 12,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M18.8807 9.68072C18.7947 8.83042 18.6097 7.89045 17.9286 7.39647C17.4011 7.0134 16.7078 6.99924 16.0605 7.00003C14.6923 7.00003 13.3233 7.00239 11.9551 7.00318C10.639 7.00475 9.32302 7.00553 8.007 7.00711C7.45725 7.00711 6.92285 6.96384 6.41226 7.20769C5.97384 7.41692 5.63063 7.81494 5.42409 8.25779C5.1377 8.87369 5.07781 9.57139 5.04326 10.2526C4.97953 11.493 4.98644 12.7366 5.06246 13.9763C5.11851 14.8809 5.26055 15.8806 5.94313 16.4572C6.54816 16.9677 7.40196 16.9929 8.18666 16.9936C10.6774 16.996 13.169 16.9984 15.6605 16.9999C15.9799 17.0007 16.3131 16.9944 16.6387 16.9583C17.279 16.8875 17.8894 16.6995 18.301 16.2133C18.7164 15.7233 18.8231 15.0413 18.8861 14.3955C19.0396 12.8287 19.0381 11.2468 18.8807 9.68072ZM10.5147 14.1965V9.80343L14.2278 11.9996L10.5147 14.1965Z",
		fill: "white"
	})]
});
export default SvgYoutube;
